module.exports = __webpack_public_path__ + "img/service.3d2930e7.jpg";